import css from "styled-jsx/css";
import { ALWAYS_ON_TOP } from "constants/z-index";

export const componentStyles = css.global`
  .live-board-modal {
    position: fixed;
    height: 100vh;
    width: 100vw;
    animation: modalSlide 0.3s ease-out forwards;
    transform: translateX(50%);
  }

  @keyframes modalSlide {
    from {
      transform: translateX(50%);
      opacity: 0;
    }

    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  .live-board-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    backdrop-filter: blur(10px);
    background-color: rgba(0, 0, 0, 0.1);
    z-index: ${ALWAYS_ON_TOP};
  }

  .ReactModal__Body--open {
    overflow-y: hidden;
  }
`;
